import { API_BASE_URL } from '../../constants/appConstants';
import { authenticatedRequest } from '../authService';

const SUPERADMIN_BASE_URL = `${API_BASE_URL}/superadmin`;

/**
 * Search users for dropdown selection
 * @param {string} searchTerm - Search term for username, email, first_name, last_name
 * @param {number} limit - Maximum number of results (default: 20)
 * @returns {Promise<Object>} Response with users list
 */
export const searchUsers = async (searchTerm = '', limit = 20) => {
  // Build query string
  const queryParams = new URLSearchParams();
  if (searchTerm.trim()) queryParams.append('search', searchTerm.trim());
  queryParams.append('limit', limit.toString());

  const url = `${SUPERADMIN_BASE_URL}/users/search/?${queryParams.toString()}`;

  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });

    if (!response.success) {
      throw new Error(response.error || 'Failed to search users');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error searching users:', error);
    throw new Error(error.message || 'Failed to search users');
  }
};

/**
 * Get user summary information
 * @param {number} userId - User ID
 * @returns {Promise<Object>} Response with user summary
 */
export const getUserSummary = async (userId) => {
  if (!userId) {
    throw new Error('User ID is required');
  }

  const url = `${SUPERADMIN_BASE_URL}/users/${userId}/summary/`;

  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });

    if (!response.success) {
      throw new Error(response.error || 'Failed to fetch user summary');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching user summary:', error);
    throw new Error(error.message || 'Failed to fetch user summary');
  }
};